"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceAnalytics = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactDeviceDetect = require("react-device-detect");
var _selectors = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _constants = require("../../../Search/constants");
var _actions = require("../../store/actions");
var _selectors3 = require("../../store/selectors");
var _PriceChart = _interopRequireDefault(require("../PriceChart"));
var _Layouts = require("./components/Layouts");
var _Header = _interopRequireDefault(require("./components/Header"));
var _hocs = require("./hocs");
var _PriceProvider = require("./components/PriceProvider");
var _actions2 = require("./store/actions");
var _selectors4 = require("./store/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Operator = (0, _hocs.withOperator)(_Layouts.Square.Operator);
var PriceAnalytics = exports.PriceAnalytics = function PriceAnalytics(_ref) {
  var baseQueryID = _ref.queryID;
  var dispatch = (0, _reactRedux.useDispatch)();
  var countryID = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getQueryParam)(state, {
      queryID: baseQueryID,
      paramName: _fn.QUERY_PARAMS.COUNTRY
    });
  });
  var isProcessSelector = (0, _react.useMemo)(function () {
    return (0, _selectors3.createIsProccessSelector)(_constants.MAIN_QUERIES);
  }, []);
  var getCategories = (0, _react.useMemo)(_selectors4.createGetCategoryWithMinPriceSelector, []);
  var getDeparturesWithMinPriceWrapper = (0, _react.useMemo)(function () {
    return (0, _selectors4.createGetDeparturesWithMinPriceWrapper)(countryID);
  }, [countryID]);
  var getHotelsTotalSelector = (0, _react.useMemo)(function () {
    return (0, _selectors.getHotelsByMultipleSearch)(_constants.MAIN_QUERIES);
  }, []);
  var getOperators = (0, _react.useMemo)(_selectors4.createGetOperatorsSelector, []);
  var activeCurrency = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors2.getQueryParam)(state, {
      queryID: baseQueryID,
      paramName: _fn.QUERY_PARAMS.CURRENCY
    });
  });
  var categories = (0, _reactRedux.useSelector)(getCategories);
  var departures = (0, _reactRedux.useSelector)(getDeparturesWithMinPriceWrapper);
  var isProccessSearch = (0, _reactRedux.useSelector)(isProcessSelector);
  var operators = (0, _reactRedux.useSelector)(getOperators);
  var totalHotels = (0, _reactRedux.useSelector)(getHotelsTotalSelector);
  var visible = (0, _reactRedux.useSelector)(_selectors4.getVisible);
  var currency = (0, _react.useMemo)(function () {
    return (0, _dictionary.getCurrencyByCode)(activeCurrency);
  }, [activeCurrency]);
  var handleToggleAnalytic = (0, _react.useCallback)(function () {
    return dispatch((0, _actions2.toggleVisible)());
  }, [dispatch]);
  var handleOpenMap = (0, _react.useCallback)(function () {
    return dispatch((0, _actions.openMapByResults)(baseQueryID));
  }, [baseQueryID, dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Header.default, {
    isOpenChart: visible,
    isProccessSearch: isProccessSearch,
    totalHotels: totalHotels,
    onOpenMap: handleOpenMap,
    onToggleAnalytic: handleToggleAnalytic
  }), visible && /*#__PURE__*/_react.default.createElement(_PriceChart.default, {
    currency: currency,
    daysDuration: _reactDeviceDetect.isMobile ? 13 : 35,
    queryID: baseQueryID
  }), /*#__PURE__*/_react.default.createElement(_Layouts.Container, null, departures.length > 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _ramda.map)(function (departure) {
    return /*#__PURE__*/_react.default.createElement(_PriceProvider.PriceProvider, {
      byParamName: _fn.QUERY_PARAMS.DEPARTURES,
      byParamValue: departure.id,
      currency: currency,
      offerID: departure.offerID,
      key: departure.id,
      queryID: departure.queryID
    }, function (price, onClickByPrice) {
      return /*#__PURE__*/_react.default.createElement(_Layouts.Square.Departure, {
        name: departure.name,
        loading: isProccessSearch,
        price: price,
        onClick: onClickByPrice
      });
    });
  }, departures), /*#__PURE__*/_react.default.createElement(_Layouts.Divider, null)), (0, _ramda.map)(function (operator) {
    return /*#__PURE__*/_react.default.createElement(_PriceProvider.PriceProvider, {
      byParamName: _fn.QUERY_PARAMS.OPERATORS,
      byParamValue: operator.id,
      currency: currency,
      offerID: operator.offerID,
      key: operator.id,
      queryID: operator.queryID
    }, function (price, onClickByPrice) {
      return /*#__PURE__*/_react.default.createElement(Operator, {
        countryID: countryID,
        loading: !operator.isReady,
        operatorID: operator.id,
        price: price,
        queryID: operator.queryID,
        onClick: onClickByPrice
      });
    });
  }, operators), !(0, _ramda.isEmpty)(categories) && /*#__PURE__*/_react.default.createElement(_Layouts.Divider, null), (0, _ramda.map)(function (category) {
    return /*#__PURE__*/_react.default.createElement(_PriceProvider.PriceProvider, {
      byParamName: _fn.QUERY_PARAMS.CATEGORY,
      byParamValue: category.category,
      currency: currency,
      offerID: category.offerID,
      key: category.category,
      queryID: category.queryID
    }, function (price, onClickByPrice) {
      return /*#__PURE__*/_react.default.createElement(_Layouts.Square.Caregory, {
        category: category.category,
        loading: isProccessSearch,
        price: price,
        onClick: onClickByPrice
      });
    });
  }, categories)));
};
PriceAnalytics.propTypes = {
  queryID: _propTypes.default.string.isRequired
};